import React, {useState,useContext} from "react";
import {useTranslate} from 'react-polyglot';
import CustomMonoriel from "../../services/CustomMonoriel";
import { DialogActions, DialogButton } from '@rmwc/dialog';
import ShowLoadingContext from '../../context/ShowLoadingContext';
import Appcontext from '../app/AppContext';
import "./editAR.scss";
import { TextField} from '@mui/material';
import { Snackbar, SnackbarAction } from '@rmwc/snackbar';
import CoaTextField from "../textfield";
import ActionButtons from "../actionsDialog/ActionButtons";

export default function ChangeAlias(props) {
    const context = useContext(Appcontext);
    const t = useTranslate();
    const [alias, setAlias] = useState(props.data)
    const { setShowLoading } = useContext(ShowLoadingContext)
    const [open,setOpen] = useState({
        title: '',
        subtitle: '',
        isOpen: false,
        icon: ''
    })

    async function changeAlias() {
        try {
            setShowLoading(true);
            const aliasNormalizado = alias.replace(/\s+/g, ''); 
            await CustomMonoriel.changeMoesAlias(props.keyData, aliasNormalizado);
            const formData = new FormData();
            formData.append('newAlias', aliasNormalizado);
            await CustomMonoriel.changeCletusAlias(props.data,formData)
            setOpen({
                title: t('experiences.success'),
                subtitle: t('experiences.successBody'),
                isOpen: true,
                icon: 'check'
            });
            setShowLoading(false);
            context.page.refetch();
        } catch (error) {
            console.log('error', error);
            setShowLoading(false);
            setOpen({
                subtitle: t('experiences.error'),
                isOpen: true,
                icon: 'error'
            });
        }
    }

    return (
        <div className={`coa-dialog-form coa-dialog-with-action-buttons`}>
            <CoaTextField
                data={alias}
                onChange={setAlias}
                label={t('experiences.newAlias')}
            />
            <ActionButtons
                cancelText={t('actions.cancel')}
                acceptText={t('actions.accept')}
                acceptDisabled={alias.trim() === '' || alias.trim() === props.data}
                onClickCancel={() => {}}
                onClickAccept={changeAlias}
            ></ActionButtons>
            <Snackbar
                open={open.isOpen}
                message={open.subtitle}
                dismissesOnAction
                action={
                    <SnackbarAction icon={open.icon}/>
                }
            /> 
        </div>
    )
}
